import React from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  ListItemText,
  makeStyles,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { gpColors } from "../../constants/colors";
import { useState } from "react";
import SideDrawer from "./Drawer";
import { useEffect } from "react";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import { getCookie } from "../../Functions";
import AddProductValMOdal from "./AddProductValMOdal";
import ProductDetails from "./ProductDetails";
import api from "../Interceptors/axiosInstance";

const useStyles = makeStyles((theme) => ({
  roots: {
    display: "flex",
    height: "auto",
  },
  content: {
    backgroundColor: "#EAE4E8",
    flexGrow: 1,
    paddingTop: "84px",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    height: "100%",
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    paddingBottom: 20,
  },
  root: {
    padding: "30px",
    minHeight: "280px",
    marginTop: "20px",
  },
  fieldBox: {
    width: "48%",
    margin: 5,
    [theme.breakpoints.only("xs")]: {
      width: "100%",
    },
    [theme.breakpoints.only("sm")]: {
      width: "100%",
    },
  },
  textFieldStyle: {
    width: "100%",
    height: "40px",
  },
  selectFieldStyle: {
    width: "100%",
    height: "40px",
    [theme.breakpoints.only("xs")]: {
      width: "95%",
    },
    [theme.breakpoints.only("sm")]: {
      width: "98%",
    },
  },
  submitButton: {
    textTransform: "none",
    backgroundColor: gpColors.logoBrown,
    color: "#fff",
    marginBottom: "12px",
    width: "20%",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
    [theme.breakpoints.down("sm")]: {
      width: "70%",
    },
    [theme.breakpoints.only("md")]: {
      width: "30%",
    },
  },
  loaderContainer: {
    textAlign: "center",
    color: "#BE0A00",
    alignItems: "center",
    backgroundColor: "",
    display: "flex",
    justifyContent: "center",
    height: "30vh",
  },
}));

function AddProducts() {
  const classes = useStyles();
  const [userData, setUserData] = useState({});
  const [productCategoryList, setProductCategoryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [updateData, setUpdateData] = useState(false); //when submit button click then update product details
  const [addProductData, setAddProductData] = useState({
    gpa: "",
    product_category_id: "",
    brand_id: [],
    brand_no: [],
    application: "",
    image: "",
    brandDetails: [],
  });
  const [brandName, setBrandName] = useState([]);
  const [imgSizeError, setImgSizeError] = useState("");

  const [validationModal, setValidationModal] = useState(false);
  function openValidationModal() {
    setValidationModal(true);
  }
  function closeValidationModal() {
    setValidationModal(false);
  }

  const [alert, setAlert] = useState({
    alertStatus: false,
    alertMessage: "",
    alertColor: "",
  });

  // Alert box close
  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({
      ...alert,
      alertStatus: false,
      alertColor: "",
      alertMessage: "",
    });
  };

  //Getting brand List for form dropdown
  const getBrandList = async () => {
    setLoader(true);
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/getBrandsList`,
      //   {
      //     method: "GET",
      //     headers: {
      //       "Access-Control-Allow-Origin": "*",
      //       Authorization: `Token ${userVal.loginInfo.data.jwt}`,
      //       // // "ngrok-skip-browser-warning": "true",
      //     },
      //   }
      // );
      const resp = await api.get(`/getBrandsList`);
      console.log("brand list: ", resp);
      const data = await resp.data;
      setBrandList(data);
      setLoader(false);
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  //Getting product category list for form dropdown
  const getProductCategoryList = async () => {
    // fetch(
    //   `${process.env.REACT_APP_API_ENDPOINT}/getProductCategory`,
    //   {
    //     method: "GET",
    //     headers: {
    //       // // "ngrok-skip-browser-warning": "true",
    //       Authorization: `Token ${userVal.loginInfo.data.jwt}`,
    //     },
    //   }
    // )
    //   .then((response) => response.json())
    //   .then((json) => setProductCategoryList(json));
    const resp = await api.get(`/getProductCategory`);
    const data = await resp.data;
    setProductCategoryList(data);
  };

  //Getting cookies
  // const getLoginInfoData = () => {
  //   const getValue = getCookie("guardPlus_user");
  //   if (getValue !== null) {
  //     const decryptedValue = CryptoAES.decrypt(getValue, "secretKey");
  //     const userVal = JSON.parse(decryptedValue.toString(CryptoENC));
  //     // console.log(userVal);
  //     setUserData(userVal);
  //     getBrandList(userVal);
  //     getProductCategoryList(userVal);
  //   }
  // };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    // getLoginInfoData();
    getProductCategoryList();
    getBrandList();
  }, []);

  function handleFormChange(e, para, position) {
    let value = e.target.value;
    let name = e.target.name;
    if (para === "brandList") {
      // console.log('value', value)
      setBrandName(
        // On autofill we get a stringified value.
        typeof value === "string" ? value.split(",") : value
      );
      let bId = [];
      let b = [...addProductData.brandDetails];

      value.forEach((item, index) => {
        let filterByBrand = brandList.filter((i) => i.brand === item);
        bId.push(filterByBrand[0].id);
        setAddProductData({ ...addProductData, brand_id: bId });

        // set brand name, id and brandvalue only once and not override
        if (
          b.findIndex((element) => element.id === filterByBrand[0].id) === -1
        ) {
          b.push({
            id: filterByBrand[0].id,
            brandName: filterByBrand[0].brand,
            brandValue: "",
          });
        }
        setAddProductData({
          ...addProductData,
          brand_id: bId,
          brandDetails: b,
        });
      });

      // if checkbox is unchecked in that case also delete from brandDetails
      let finalBrandData = [];
      if (b.length > bId.length) {
        bId.forEach((item) => {
          finalBrandData.push(b.find((element) => element.id === item));
        });
        // if unchecked brand checkbox in that case there value also delete from brandno
        let a = [];
        finalBrandData.forEach((value, index) => {
          a.push(value.brandValue);
        });
        // setAddProductData({ ...addProductData, brand_no: a });
        setAddProductData({
          ...addProductData,
          brand_id: bId,
          brandDetails: finalBrandData,
          brand_no: a,
        });
      }
    } else if (para === "brandValue") {
      let b = [...addProductData.brandDetails];
      b[position].brandValue = value;
      let a = [];
      b.forEach((value, index) => {
        a.push(value.brandValue);
      });
      setAddProductData({ ...addProductData, brandDetails: b, brand_no: a });
    } else if (para === "imageFile") {
      // image size not greater than 10MB
      let file = e.target.files[0];
      if (file.size > 10e6) {
        setImgSizeError("Please upload a file smaller than 10 MB.");
        setAddProductData({ ...addProductData, [name]: "" });
      } else {
        setImgSizeError("");
        setAddProductData({ ...addProductData, [name]: file.name });
      }
    } else {
      setAddProductData({ ...addProductData, [name]: value });
    }
  }
  // console.log(addProductData)
  // console.log(imgSizeError)
  const checkValidation = async () => {
    console.log(addProductData);
    let result = true;

    //validations for form fields
    Object.keys(addProductData).forEach(function (key) {
      if (addProductData[key].length === 0) {
        result = false;
        openValidationModal();
      } else if (key === "brandDetails") {
        addProductData[key].forEach((item, index) => {
          if (item.brandValue.length === 0) {
            result = false;
            openValidationModal();
          }
        });
      }
    });

    // when all fields are filled then save data
    if (result) {
      submitForm();
    }
  };

  const submitForm = async () => {
    setBtnLoader(true);
    // The FormData interface provides a way to construct a set of
    // key/value pairs representing form fields and their values,
    // which can be sent using the fetch()
    const formData = new FormData();
    const fileField = document.getElementById("file");
    formData.append("gpa", `${addProductData.gpa}`);
    formData.append(
      "product_category_id",
      `${addProductData.product_category_id}`
    );
    formData.append("brand_id", addProductData.brand_id);
    formData.append("brand_no", addProductData.brand_no);
    formData.append("application", `${addProductData.application}`);
    formData.append("image", fileField.files[0]);
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/saveProducts`,
      //   {
      //     method: "POST",
      //     body: formData,
      //     headers: {
      //       // // "ngrok-skip-browser-warning": "true",
      //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
      //     },
      //   }
      // );
      // const resp = await api.post(`/saveProducts`, formData)
      const resp = await api.post("/saveProducts", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      const data = await resp.data;
      console.log(data);
      setBtnLoader(false);
      if (data.hasOwnProperty("message")) {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "Something went wrong please try again.",
        });
      } else if (data.hasOwnProperty("result")) {
        if (data.result === "Success") {
          setUpdateData(true);
          setAlert({
            ...alert,
            alertStatus: true,
            alertColor: "green",
            alertMessage: "New product data has been saved successfully!!",
          });
          setAddProductData({
            gpa: "",
            product_category_id: "",
            brand_id: [],
            brand_no: [],
            application: "",
            image: "",
            brandDetails: [],
          });
          setBrandName([]);
          setImgSizeError("");
          document.getElementById("file").value = "";
        } else if (data.result === "GPA already exists") {
          //in some case file not saved in that case show alert box
          setAlert({
            ...alert,
            alertStatus: true,
            alertColor: "red",
            alertMessage: "GPA is already exists please try another one.",
          });
        }
      }
    } catch (e) {
      console.log(e.message);
      setBtnLoader(false);
    }
  };

  return (
    <div className={classes.roots}>
      <SideDrawer tabName="products" userData={userData} />
      <main className={classes.content}>
        <div className={classes.title}>Add Products</div>
        <Divider />

        <Card className={classes.root}>
          <CardContent>
            {loader && (
              <Box className={classes.loaderContainer}>
                <CircularProgress color="inherit" />
              </Box>
            )}
            {!loader && (
              <>
                <Box display="flex" flexWrap="wrap">
                  <Box className={classes.fieldBox}>
                    <Typography>
                      Product Category<label style={{ color: "red" }}>*</label>
                    </Typography>
                    <Select
                      className={classes.textFieldStyle}
                      variant="outlined"
                      size="small"
                      defaultValue=""
                      name="product_category_id"
                      value={addProductData.product_category_id}
                      onChange={(e) => handleFormChange(e)}
                      MenuProps={{
                        getContentAnchorEl: null,
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                      }}
                    >
                      {productCategoryList.map((item, index) => (
                        <MenuItem value={item.id} key={index}>
                          {item.product_category}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                  <Box className={classes.fieldBox}>
                    <Typography>
                      GPA#<label style={{ color: "red" }}>*</label>
                    </Typography>
                    <TextField
                      variant="outlined"
                      // fullWidth
                      size="small"
                      className={classes.textFieldStyle}
                      name="gpa"
                      value={addProductData.gpa}
                      onChange={(e) => handleFormChange(e)}
                    />
                  </Box>
                  <Box width="100%">
                    <Box className={classes.fieldBox}>
                      <Typography>
                        Brand<label style={{ color: "red" }}>*</label>
                      </Typography>
                      <Select
                        className={classes.selectFieldStyle}
                        variant="outlined"
                        id="brand-checkbox"
                        multiple
                        value={brandName}
                        onChange={(e) => handleFormChange(e, "brandList")}
                        input={<OutlinedInput />}
                        renderValue={(selected) => selected.join(",")}
                        MenuProps={{
                          getContentAnchorEl: null,
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                        }}
                      >
                        {brandList.map((bData, bIndex) => (
                          <MenuItem key={bIndex} value={bData.brand}>
                            <Checkbox
                              checked={brandName.indexOf(bData.brand) > -1}
                              size="small"
                            />
                            <ListItemText primary={bData.brand} />
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    <Box display="flex" flexWrap="wrap">
                      {brandName.length !== 0 &&
                        brandName.map((value, position) => (
                          <Box className={classes.fieldBox} key={position}>
                            <Typography>
                              {value}
                              <label style={{ color: "red" }}>*</label>
                            </Typography>
                            <TextField
                              variant="outlined"
                              size="small"
                              className={classes.textFieldStyle}
                              onChange={(e) =>
                                handleFormChange(e, "brandValue", position)
                              }
                            />
                          </Box>
                        ))}
                    </Box>
                  </Box>
                  <Box className={classes.fieldBox}>
                    <Typography>
                      Application<label style={{ color: "red" }}>*</label>
                    </Typography>
                    <TextField
                      variant="outlined"
                      // fullWidth
                      size="small"
                      className={classes.textFieldStyle}
                      name="application"
                      value={addProductData.application}
                      onChange={(e) => handleFormChange(e)}
                    />
                  </Box>
                  <Box className={classes.fieldBox}>
                    <Typography>
                      Upload Image<label style={{ color: "red" }}>*</label>
                    </Typography>
                    <input
                      type="file"
                      id="file"
                      style={{ paddingTop: "10px", paddingBottom: "10px" }}
                      name="image"
                      onChange={(e) => handleFormChange(e, "imageFile")}
                    />
                    <Box>
                      <Typography variant="caption" color="error">
                        {imgSizeError}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box display="flex" justifyContent="center" marginTop={2}>
                  <Button
                    type="submit"
                    className={classes.submitButton}
                    onClick={() => checkValidation()}
                  >
                    {btnLoader ? <CircularProgress size={25} /> : "SUBMIT"}
                  </Button>
                </Box>
              </>
            )}
          </CardContent>
        </Card>
        <ProductDetails
          userData={userData}
          updateData={updateData}
          setUpdateData={setUpdateData}
        />
      </main>

      {/* Validation modal and alert box for API results component */}
      <AddProductValMOdal
        validationModal={validationModal}
        closeValidationModal={closeValidationModal}
        handleAlertClose={handleAlertClose}
        alert={alert}
      />
    </div>
  );
}

export default AddProducts;
